import Link from 'next/link';
import cn from 'classnames';
import styles from './anchor-arrow.module.css';
import { ms } from 'date-fns/locale';
import { transform } from 'lodash';

const AnchorArrow: React.FC<{
  text: string;
  href: string;
  openInNewTab?: boolean;
  theme?: 'dark' | 'light';
  dir?: 'left' | 'down';
}> = ({ href, openInNewTab = false, text, theme = 'dark', dir = 'left' }) => {
  const isLeft = dir === 'left';

  return (
    <Link
      href={href}
      className={cn('group', linkTheme[theme])}
      target={openInNewTab ? '_blank' : '_self'}
    >
      <span className="font-medium">{text}</span>{' '}
      <span
        className={cn(
          'transition-transform duration-500 ease-out inline-block arrow font-unicode',
          isLeft ? 'group-hover:translate-x-1' : 'group-hover:translate-y-1'
        )}
      >
        {isLeft ? '→' : '↓'}
      </span>
    </Link>
  );
};

const linkTheme = {
  dark: 'text-white',
  light: 'text-link'
};

AnchorArrow.defaultProps = {
  theme: 'dark',
  href: '#',
  openInNewTab: false
};

export default AnchorArrow;
